// Bootstrap for the static first-party pages (about / help / privacy / terms /
// tools). It (1) applies the user's full Look - theme, accent, font, corners,
// density - so the site's pages match the app (the inline pre-paint in each head
// already set the instant colors; applyTheme here finalizes the web font +
// accent-2 and live-syncs cross-tab), and (2) applies homoglyph obfuscation when
// the user has obfuscation set to maximum.
import { applyTheme } from "./app/theme.js";
import { applyObfuscation } from "./shared/obfuscate.js";
import { get, subscribe } from "./shared/settings-store.js";

// pages marked data-plain (/schools, /accessibility) always stay readable
const plain = document.documentElement.hasAttribute("data-plain");
function syncObf() { applyObfuscation(!plain && get("obfuscation") === "max"); }

applyTheme();
syncObf();
// Keep the page's look + obfuscation in sync if changed in the settings tab.
subscribe(() => { applyTheme(); syncObf(); });
